<template>
  <div>
    <vue-svg-gauge
      v-if="isWithAllInformation"
      :start-angle="-110"
      :end-angle="110"
      :value="machineHealthIndex.value"
      :separator-step="25"
      :min="0"
      :max="100"
      style="max-width: 80%; max-height:80%"
      base-color="#DDDDDD"
      :gauge-color="[
        { offset: 20, color: '#B81D13' },
        { offset: 50, color: '#EFB700' },
        { offset: 90, color: '#008450' }
      ]"
      :scale-interval="25"
    >
      <div class="caption inner-text inner-text--3">
        <span>{{ machineHealthIndex.name }}</span>
      </div></vue-svg-gauge
    >
    <div v-else class="optional">
      <v-card class="pa-10" color="secondary" dark>
        Not enough operational or reliability information yet
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { VueSvgGauge } from "vue-svg-gauge";
export default {
  components: {
    VueSvgGauge
  },
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    operations() {
      return this.equipmentProfile?.lastInspection?.status;
    },
    reliablities() {
      return this.equipmentProfile?.status;
    },
    isWithAllInformation() {
      return this.operations && this.reliablities?.value ? true : false;
    },
    machineHealthIndex() {
      // Chequea si existe un valor en reliabilities, caso contrario hace la comprobacion de si el valor es mayor a 1 comprobando que no sea running, y por ultimo si es running, devuelve el valor del traffic light de running
      function switchRunning(value) {
        switch (value) {
          case 1:
            return 100;
          case 2:
            return 80;
          case 3:
            return 45;

          default:
            return 0;
        }
      }
      function switchDowntime(value) {
        switch (value) {
          case 2:
            return 60;
          case 3:
            return 30;
          case 4:
            return 10;

          default:
            return 0;
        }
      }
      const operations = this.operations;
      const reliabilities = this.reliablities;
      if (!reliabilities?.value) {
        return {
          trafficLight: { value: 0, name: "N/A ", color: "#B81D13" },
          name: "N/A ",
          value: 0,
          color: "#B81D13"
        };
      } else if (reliabilities?.value > 1) {
        reliabilities.value = switchDowntime(reliabilities.value);
        return reliabilities;
      } else {
        if (operations?.value > reliabilities?.trafficLight?.value) {
          operations.value = switchRunning(operations.value);
          return operations;
        } else {
          reliabilities.name = reliabilities.trafficLight.name;
          reliabilities.color = reliabilities.trafficLight.color;
          reliabilities.value = switchRunning(reliabilities.trafficLight.value);
          return reliabilities;
        }
      }
    },
    lastInspection() {
      return this.equipmentProfile?.lastInspection?.status;
    }
  }
};
</script>
<style lang="stylus" scope="this api replaced by slot-scope in 2.5.0+">
.inner-text {
  &--1, &--3 {
    display: flex;
    justify-content: center;
    margin-top: 85px;
    font-size: 15px;
    font-weight: bold;

    span {
      max-width: 100px;
    }
  }

  &--3 {
    margin-top: 70px;
  }

  &--2 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: bold;

    span {
      max-width: 90px;
    }
  }
}
.optional {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70%;
  .v-card {
    width: 100%
  }
}
</style>
